export default {
      id: "plantSatellite-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "icons.svg#plantSatellite",
      toString: function () {
        return this.url;
      }
    }